module.exports = __webpack_public_path__ + "img/sales.b8d000d8.png";